var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _vm.openBackdrop
      ? _c(
          "div",
          { staticClass: "slider-backdrop" },
          [
            _c("transition", { attrs: { name: "slide" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.openSlider,
                      expression: "openSlider",
                    },
                  ],
                  staticClass: "slider",
                },
                [
                  _c(
                    "div",
                    { staticClass: "header" },
                    [
                      _c("span", { staticClass: "header-title" }, [
                        _vm._v("\n            Notifications\n            "),
                        _c("span", { staticClass: "mdi mdi-bell" }),
                      ]),
                      _vm._v(" "),
                      _c("pix-button", {
                        attrs: { iconClass: "mdi-close" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.closeSidebar.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm._l(_vm.notifications, function (entry) {
                        return _c(
                          "div",
                          { key: entry.date },
                          [
                            _c("div", { staticClass: "notification-date" }, [
                              _vm._v(_vm._s(_vm.dateAsText(entry.date))),
                            ]),
                            _vm._v(" "),
                            _vm._l(
                              entry.notifications,
                              function (notification) {
                                return _c(
                                  "div",
                                  {
                                    key: notification.NotificationId,
                                    staticClass: "notification",
                                  },
                                  [
                                    _c("span", {
                                      class: {
                                        "notification-unread":
                                          notification.IsUnread,
                                        "notification-read":
                                          !notification.IsUnread,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("pix-member-circle-row", {
                                      attrs: {
                                        names: [notification.FromUserId],
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "notification-name" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.asUsername(
                                                notification.FromUserId
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("div", [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            notification.NotificationDescription
                                          ) +
                                          "\n              "
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "buttons-and-time" },
                                      [
                                        _c("pix-button", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: notification.IsUnread,
                                              expression:
                                                "notification.IsUnread",
                                            },
                                          ],
                                          attrs: {
                                            iconClass: "mdi-email-open",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setNotificationRead(
                                                notification.NotificationId
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("pix-button", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !notification.IsUnread,
                                              expression:
                                                "!notification.IsUnread",
                                            },
                                          ],
                                          attrs: { iconClass: "mdi-email" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.setNotificationUnread(
                                                notification.NotificationId
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("pix-button", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !notification.IsUnread,
                                              expression:
                                                "!notification.IsUnread",
                                            },
                                          ],
                                          attrs: { iconClass: "mdi-delete" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteNotification(
                                                notification.NotificationId
                                              )
                                            },
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "time" }, [
                                          _vm._v(
                                            _vm._s(
                                              _vm.asTime(
                                                notification.NotificationDate
                                              )
                                            )
                                          ),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        )
                      }),
                      _vm._v(" "),
                      _c("div", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.showSpinner,
                            expression: "showSpinner",
                          },
                        ],
                        ref: "notificationsSpinner",
                        staticClass: "spinner",
                      }),
                    ],
                    2
                  ),
                ]
              ),
            ]),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }